module.exports = __webpack_public_path__ + "img/illustration-phone-mockup.c7e9aca0.svg";